export function px(value) {
  return value + 'px';
}

export function style(element, styles) {
  if (element.constructor.name == 'NodeList') {
    for (const node of element.values()) {
      style(node, styles);
    }
  } else {
    for (const name in styles) {
      element.style[name] = styles[name];
    }
  }
}

export const css = {
  px: px,
  style: style,
};
